import { Collapsible as CollapsiblePrimitive } from "radix-ui";

/**
 * Radix rather than `<details>`: the trigger must be a sibling of the panel, because the
 * section's own link stays a link, and `details` insists on owning both.
 */
const Collapsible = CollapsiblePrimitive.Root;
const CollapsibleTrigger = CollapsiblePrimitive.CollapsibleTrigger;
const CollapsibleContent = CollapsiblePrimitive.CollapsibleContent;

export { Collapsible, CollapsibleContent, CollapsibleTrigger };
